import { defineAgenda } from '@/shared/navigation/core';
import { listPageViewState } from '@/shared/navigation/react/listPageViewState';

/**
 * Agenda seznamu leteckých společností (`Inventory / Letecké společnosti`) — kořenová agenda slicu.
 * Univerzální ListPage (engine `@/shared/ui/list-page`, šablona `airlineListPage.tsx`).
 */
export const airlineListAgenda = defineAgenda({
  id: 'app.inventory.airlines',
  path: 'app/inventory/airlines',
  open: {},
  state: listPageViewState,
  title: 'Letecké společnosti',
  icon: 'plane',
});
